import { Skeleton } from "@/components/ui/skeleton";

const MessagePlaceholder = () => {
  return (
    <div className="flex flex-col gap-2 py-4">
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-3/4" />
      <Skeleton className="h-4 w-1/2" />
    </div>
  );
};

export default MessagePlaceholder;
